export const DELETE_SUCCESS = 'Коннектор удален';
export const DELETE_ERROR = 'Не удалось удалить коннектор';
